import { useCallback, useState } from 'react'

import { AtmosphereTransport, AtmosphereTransportManager } from './AtmosphereTransportManager'

const cache = AtmosphereTransportManager.getInstance()
export function useAtmosphereTransportCache() {
  const [currentTransport, setCurrentTransport] = useState<AtmosphereTransport>(() => cache.getCurrentTransport())

  const setTransport = useCallback((transport: AtmosphereTransport) => {
    cache.setCurrentTransport(transport)
    setCurrentTransport(cache.getCurrentTransport())
  }, [])

  return {
    currentTransport,
    setCurrentTransport: setTransport,
  }
}
